/*
 * 機能別コンポーネント 発注検索パネル画面で使用するconst・interface・types
 * ・更新履歴
 *   2020/12/25 ファイル作成 小林
 *   2020/12/28 使用用途等コメント追加 小林
 */

// 発注検索パネルのステータス項目内ボタン情報
export const chipsStatusItemArray = [
  {text: "新規", value: true, color:"success"},
  {text: "依頼中", value: true, color:"success"},
  {text: "⼊⼿済", value: true, color:"success"},
  {text: "完了", value: true, color:"success"}
];

// 発注検索パネル内の複数行テキスト項目内情報
export const InputAreaArray = [
  {
    labelName: '見積No',
    labelText: '見積No',
    inpuType: 'text',
    inputName: '',
    inputValue: '',
    placeholder: '',
    maxlength: "10",
    isDisabled: false
  }
];

// 発注検索パネル内の日付範囲項目情報(見積依頼日)
export const DatePickerRangeAreaArray1= {
  labelText: '見積依頼日',
  minDate: '2021-01-01',
  maxDate: '2021-01-10',
  valueFrom: '2021-01-02',
  valueTo: '2021-01-11',
  nameFrom: 'From見積依頼日',
  nameTo: 'To見積依頼日'
};

// 発注検索パネル内の日付範囲項目情報(見積期限)
export const DatePickerRangeAreaArray2 = {
  labelText: '見積期限',
  minDate: '2021-01-11',
  maxDate: '2021-01-20',
  valueFrom: '2021-01-12',
  valueTo: '2021-01-21',
  nameFrom: 'From見積期限',
  nameTo: 'To見積期限'
};

// 発注検索パネル内の日付範囲項目情報(納⼊期限)
export const DatePickerRangeAreaArray3 = {
  labelText: '納⼊期限',
  minDate: '2021-02-01',
  maxDate: '2021-02-10',
  valueFrom: '2021-02-02',
  valueTo: '2021-02-11',
  nameFrom: 'From納⼊期限',
  nameTo: 'To納⼊期限'
};

// 下部ボタン項目情報
export const underButtonArray = [
  {
    name: "search",
    color: "primary",
    value: "検索"
  },
  {
    name: "clear",
    value: "クリア"
  }
];
